<template>
  <GenericCard
    :locked="locked"
    has-delete
    :on-delete="onCardDelete"
    :on-action="submitForm"
    :on-refresh="onCardRefresh"
    :invalid="v$.section.$invalid"
    :dirty="v$.section.$anyDirty"
    :create="create"
    title="National Security"
    :section="section"
    has-footer
    has-share
    :card-identifier="cardIdentifier"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col cols="12">
          <v-alert
            border="left"
            colored-border
            color="#2A3B4D"
            icon="mdi-information-outline"
            elevation="2"
            class="mb-6"
          >
            An applicant may be ineligible if broadly-defined political, security, or a terrorist bar applies. ; INA 208(b)(2)(A)(iv) (danger to US security); INA § 208(b)(2)(a)(v) (engaging in terrorist activity, including material support). An applicant may be ineligible if persecutor of others. INA § 208(b)(2)(A)(i). Add a module for each incident requiring analysis.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <div class="text-right">
            Putative Incident
          </div>
        </v-col>
        <v-col cols="9">
          <v-textarea
            v-model="section.putative_incident"
            auto-grow
            outlined
            autocomplete="off"
            label="Incident"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="section.narrative"
            auto-grow
            outlined
            autocomplete="off"
            label="Narrative"
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { alertHandler } from '@/alertHandler'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard'

export default {
  name: 'NationalSecuritiesCard',
  components: { GenericCard },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      section: {},
    }
  },

  validations () {
    return {
      section: {},
    }
  },

  computed: {
    cardIdentifier () { return `national-securities-card-${this.sectionIdentifier}` },
    create () { return this.item.id === null },

    locked: {
      get () {
        return this.peNationalSecuritiesCardLock(this.sectionIdentifier)
      },

      set (value) {
        this.setPeNationalSecuritiesCardLock({ index: this.sectionIdentifier, locked: value })
      },
    },

    sectionIdentifier () { return this.section.id || 'new' },

    subtitle () {
      if (this.create) return ''
      return `(${this.section.name})`
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peNationalSecuritiesCardLock',
    ]),
  },

  watch: {
    item: {
      immediate: true,

      handler: function () {
        this.section = { ...this.item }
      },

      deep: true,
    },
  },

  created () {
    if (!this.create) this.initPeNationalSecuritiesCard(this.sectionIdentifier)
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardCreate () {
      return this.peNationalSecuritiesCardCreate({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardDelete () {
      if (this.create) return this.peNationalSecuritiesCardCreateUndo()
      else {
        return this.peNationalSecuritiesCardDelete({ id: this.section.id, index: this.sectionIdentifier })
      }
    },

    async onCardRefresh () {
      return this.peNationalSecuritiesCardRefresh({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardUpdate () {
      return this.peNationalSecuritiesCardUpdate({
        id: this.section.id,
        index: this.sectionIdentifier,
        section: this.section,
      })
    },

    async onSectionUnlock () {
      return this.setPeNationalSecuritiesCardLock({ index: this.sectionIdentifier, locked: false })
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else if (this.create) return this.onCardCreate()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'peNationalSecuritiesCardCreateUndo',
      'setPeNationalSecuritiesCardLock',

    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeNationalSecuritiesCard',
      'peNationalSecuritiesCardCreate',
      'peNationalSecuritiesCardDelete',
      'peNationalSecuritiesCardRefresh',
      'peNationalSecuritiesCardUpdate',
    ]),
  },
}
</script>
